/** @flow */
import React from 'react'
import { SnackbarProvider } from 'notistack'
import { NotificationsPublisher } from './NotificationsPublisher.jsx'

type Props = {|
  children: *,
|}

export function NotificationsHOC(props: Props): React$Node {
  const { children } = props

  return (
    <SnackbarProvider
      maxSnack={5}
      style={{ zIndex: 10000 }}
      classes={{
        variantSuccess: { backgroundColor: '#48C27E' },
        variantError: { backgroundColor: '#E56D7A' },
        variantWarning: { backgroundColor: '#E3E05B' },
        variantInfo: { backgroundColor: '#00639A' },
      }}
    >
      <NotificationsPublisher>{children}</NotificationsPublisher>
    </SnackbarProvider>
  )
}
